// removed by extract-text-webpack-plugin
module.exports = {"container":"event-guest-chat-photo-cell__container__sb5E7","cell-title":"event-guest-chat-photo-cell__cell-title__2uiFs","cell-item":"event-guest-chat-photo-cell__cell-item__n1CGu","pane-wrap":"event-guest-chat-photo-cell__pane-wrap__rz70t","pane-text":"event-guest-chat-photo-cell__pane-text__3aCon","hidden-text":"event-guest-chat-photo-cell__hidden-text__1yu-i","pane-chevron-icon":"event-guest-chat-photo-cell__pane-chevron-icon__37Ga3","add-guest-button":"event-guest-chat-photo-cell__add-guest-button__1kbER","button":"event-guest-chat-photo-cell__button__3LW4w"};


//////////////////
// WEBPACK FOOTER
// ./src/components/details/event-guest-chat-photo-cell.scss
// module id = 1349
// module chunks = 1